import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=304c9e3e&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=js&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRadio.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports